import { Typography } from '@mui/material';

import { WEBHOOK_EVENTS } from 'src/pages/setting/components/webhooks/components/webhook-form';

// ----------------------------------------------------------------------

type Props = {
  row: any;
  t: (key: string) => string;
};

// ----------------------------------------------------------------------

export function RowCellWebhookUrl({ row, t }: Props) {
  const updateEventLabels =
    'events' in row && Array.isArray(row.events)
      ? row.events.map((eventKey: string) => {
          const match = WEBHOOK_EVENTS(t).find((item: any) => item.key === eventKey);
          return match?.label || eventKey;
        })
      : [];

  const joinedLabels = updateEventLabels.join(', ');
  const url = 'url' in row && row.url;

  if (!joinedLabels) {
    return null;
  }

  return (
    <>
      <Typography color="text.primary">{typeof url === 'string' ? url : ''}</Typography>
      <Typography
        component="span"
        variant="body2"
        color="text.secondary"
        sx={{ display: 'block', fontSize: 'inherit' }}
      >
        <strong>{t('SUBSCRIBE_EVENTS')}:</strong> {joinedLabels}
      </Typography>
    </>
  );
}
